import { ConfirmationDialog } from '@fortem-monorepo/react-ui'

import { useMarketSummaryContext } from '@/pages/instruments/market-summary/market-summary-context'
import { useRemoveMetricFromDisplayMutation } from '@/pages/instruments/market-summary/market-summary.mutations'

export interface RemoveMetricDialogProps {
  open: boolean
  onClose: () => void
  mutationParams: { display_id: number; display_metric_id: number }
}

export const RemoveMetricDialog = ({ open, onClose, mutationParams }: RemoveMetricDialogProps) => {
  const { metricsQuery, hasWriteAccess } = useMarketSummaryContext()
  const metric = metricsQuery.data?.find(
    (row) => row.display_id === mutationParams.display_id && row.display_metric_id === mutationParams.display_metric_id,
  )
  const mutation = useRemoveMetricFromDisplayMutation()

  return (
    <ConfirmationDialog
      open={open}
      title="Remove Metric"
      description="This removes this metric from its Market Summary display."
      pending={mutation.isPending}
      valid={hasWriteAccess}
      onClose={() => {
        if (!mutation.isPending) onClose()
      }}
      action={() => {
        if (!hasWriteAccess || mutation.isPending) return
        mutation.mutate(mutationParams, { onSuccess: onClose })
      }}
    >
      <p className="text-sm">{metric?.definition ?? `Metric ${mutationParams.display_metric_id}`}</p>
      <p className="text-sm text-muted-foreground">Display {mutationParams.display_id}</p>
    </ConfirmationDialog>
  )
}
